<template>
  <div id="map" class="fill-width fill-height">
    <the-mobile-map-buttons class="mobile-map-buttons" />
    <the-mobile-map-legend class="mobile-map-legend" />
  </div>
</template>
<script>
import { get } from 'vuex-pathify';

import Map from 'ol/Map';
import View from 'ol/View';
import { Group as LayerGroup } from 'ol/layer';

import featuresData from '@/mixins/map/featuresData';
import identification from '@/mixins/map/identification';
import map from '@/mixins/map/map';
import styles from '@/mixins/map/styles';

import TheMobileMapButtons from '@/components/mobile/TheMobileMapButtons';
import TheMobileMapLegend from '@/components/mobile/TheMobileMapLegend';

export default {
  name: 'TheMobileMap',
  mixins: [featuresData, identification, map, styles],
  components: { TheMobileMapButtons, TheMobileMapLegend },
  computed: {
    currentTab: get('tools/currentTab'),
  },
  data: () => ({
    map: undefined,
  }),
  methods: {
    initMap() {
      this.map = new Map({
        target: 'map',
        layers: [
          new LayerGroup({
            name: 'projectLayers',
          }),
        ],
        view: new View({
          projection: this.$_config.mapDataCoordinateSystem?.epsg,
          center: this.$_config.mapDataCoordinateSystem?.center,
          constrainResolution: true,
          zoom: this.$_config.mapDefaultZoom,
          maxZoom: this.$_config.mapDefaultMaxZoom,
          minZoom: this.$_config.mapDefaultMinZoom,
        }),
        controls: [],
      });
      this.toggleProject();
      this.toggleIdentification(true);
      this.map.on('moveend', e => {
        const { map } = e;
        this.setZoom(map);
      });
    },
  },
  watch: {
    currentTab: {
      handler(nV) {
        if (nV === 1) {
          setTimeout(() => {
            this.map?.updateSize();
          }, 100);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
#map {
  width: 100vw;
  height: calc(100dvh - 120px);
}
.mobile-map-buttons {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}
.mobile-map-legend {
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 1;
}
::v-deep {
  .mobile-map-button-shadow {
    box-shadow: 0px 4px 4px 0px #00000040;
  }
}
</style>
